import { isEmpty } from 'lodash';

import { TAnalyticsEventSchema } from '@shared/types';

import { store } from '@/redux/store/store';
import { usePFBRoutes } from '@/hooks/usePFBRoutes';
import { pfbAnalyticsClient } from '@/data/analyticsClient';
import TestModeService from '@/services/testMode.service';

import { getMerchantType } from './helper';

type IFoxtrotEventData = {
	name: string;
	value: string;
	userId: string;
	merchantId: string;
	merchantUserId: string;
	merchantType: 'OFFLINE_MERCHANT' | 'ONLINE_MERCHANT';
	additionalData: Record<string, unknown>;
	pageName: string;
	testMode: boolean;
};

/**
 * @description This function is to normalize the event data and convert it into a format that can be pushed to foxtrot.
 * @param data {TAnalyticsEventSchema}
 */
export const normalizeFoxtrotEventData = (
	data: TAnalyticsEventSchema,
): TAnalyticsEventSchema => {
	const rootStore = store?.getState();
	const {
		userId,
		merchantUserId,
		groupValue: merchantId,
	} = rootStore?.userAuth?.user || {};

	const { merchantDetails } = rootStore?.merchantProfile || {};
	const merchantType = merchantDetails
		? getMerchantType(merchantDetails.type)
		: undefined;

	const { eventData, ...eventMeta } = data;
	const { name, value, additionalData } = eventData;
	const finalEventData = {
		...eventMeta,
		eventData: {
			name,
			value: value ?? 'NA',
			userId,
			merchantId,
			merchantUserId,
			merchantType,
			pageName: usePFBRoutes.getData()?.data.pageName ?? '',
			testMode: TestModeService.isTestModeEnabled(),
		} as IFoxtrotEventData,
	};

	if (!isEmpty(additionalData)) {
		finalEventData.eventData.additionalData = additionalData;
	}
	return finalEventData;
};

export const sendEventToFoxtrot = (data: TAnalyticsEventSchema) => {
	const rootStore = store?.getState();

	const { userId, groupValue: merchantId } = rootStore?.userAuth?.user || {};

	if (!userId || !merchantId) {
		if (data.pushToQueue) {
			pfbAnalyticsClient.pushEventToQueue(data); // Push to temporary queue if pushToQueue is true
		}
		return; // skip events for non-logged-in scenarios
	}

	const normalizedEventData = normalizeFoxtrotEventData(data);
	pfbAnalyticsClient.sendFoxtrotEvent(normalizedEventData);
};
